import React, { useState } from "react";
import TrailingParagraph from "../../../animations/TrailingParagraph";
import IntersectionBox from "../../../animations/IntersectionBox";
import { zoomInWithDelay } from "../../../animations/variants";
import { motion, AnimateSharedLayout } from "framer-motion";
import Modal from "../../../components/modal";
import truncate from "lodash/truncate";
import { useWindowSize } from "react-use";
import { BsArrowRight } from "react-icons/bs";

function PPCard({
  title,
  visible_description,
  expanded_description,
  grades,
  img,
  index,
}) {
  const [open, setOpen] = useState(false);
  const { x, y } = useWindowSize();
  const [truncatingLength, setTruncatingLength] = React.useState(80);

  React.useEffect(() => {
    if (x / y > 1.2 && x / y < 1.6) {
      setTruncatingLength(40);
    }
  }, [x]);

  return (
    <>
      <motion.div
        className="card"
        whileHover={{ scale: 1.05 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <h4 className="material-name processing-head">{title} </h4>
        <p className="material-desc">
          {truncate(visible_description, { length: truncatingLength })}
          {/* {visible_description} */}
        </p>
        <p className="learn-more">
          <BsArrowRight />
        </p>
      </motion.div>

      <Modal open={open} setOpen={setOpen}>
        <div className="material-modal">
          <div
            className="image"
            style={{
              backgroundImage:
                `url(${img})` +
                ",linear-gradient(180deg, rgb(254, 254, 254) 0%, rgb(249, 249, 249) 100%)",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              height: "300px",
              backgroundPosition: "center",
            }}
          >
            {/* <img src={img} /> */}
          </div>
          <div className="content">
            <div className="header">{title}</div>
            <div className="description">
              {visible_description}&nbsp;{expanded_description}
            </div>
            {grades.length > 0 && (
              <div className="grades">
                <ul>
                  {grades.map((grade, index) => (
                    <li>{grade}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
}

PPCard.defaultProps = {
  title: "Post Processing",
  visible_description: "Post Processing Description",
  expanded_description: "Post Processing Expanded Description",
  grades: [],
  img:
    "https://images.pexels.com/photos/1005644/pexels-photo-1005644.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  index: 0,
};

function PostProcessing({ title, pp }) {
  return (
    <div className="post-processing-section materials-section">
      <h3 className="materials-head">{title}</h3>

      <div className="container-fluid">
        <div className="row processing-row">
          {pp.map((method, index) => (
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <PPCard
                title={method.PP_title}
                visible_description={method.visible_text}
                expanded_description={method.expanded_text}
                index={index}
                img={method.PP_image?.image?.url}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

PostProcessing.defaultProps = {
  title: "Post Processing",
  pp: [
    {
      PP_title: "Aluminium",
      PP_image: "",
      expanded_text: "Some Random Description",
      visible_text: "Some Random Visible Description",
      grades: [],
      image: "",
    },
    {
      PP_title: "Aluminium",
      expanded_text: "Some Random Description",
      visible_text: "Some Random Visible Description",
      grades: [],
      image: "",
    },
    {
      PP_title: "Aluminium",
      expanded_text: "Some Random Description",
      visible_text: "Some Random Visible Description",
      grades: [],
      image: "",
    },
    {
      PP_title: "Aluminium",
      expanded_text: "Some Random Description",
      visible_text: "Some Random Visible Description",
      grades: [],
      image: "",
    },
    {
      PP_title: "Aluminium",
      expanded_text: "Some Random Description",
      visible_text: "Some Random Visible Description",
      grades: [],
      image: "",
    },
  ],
};

export default PostProcessing;
